import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  categoryListingSearchService,
  categoryListingService,
} from "../../../services/MasterDataManagementService";
import CategoryList from "./CategoryList";
import useGlobalState from "../../../Context";

const ProductCategory = () => {
  const [totalElements, setTotalElements] = useState(0);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [categoryList, setCategoryList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchCategoryList("categoryName", false);
  }, []);

  const fetchCategoryList = async (sortBy, isAsc,searchValue,paginationObject) => {
    try {
      setLoading(true);
      const requestBody = {
        pageSize: paginationObject?.pageSize ?? 10,
        pageNumber: paginationObject?.pageNumber ?? 0,
        filterSearch:searchValue ? searchValue : null,
        active: 2,
        sortBy: sortBy,
        sortDirection: isAsc ? "DESC" : "ASC",
      };
      const categoryListingResponse = await categoryListingService(requestBody);
      if (categoryListingResponse.statusCode === 6) {
        if (categoryListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setCategoryList(categoryListingResponse.data.content);
        setTotalElements(categoryListingResponse.data.totalElements);
      } else {
        showNotification("Error", categoryListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "fail to fetch category listing", "error");
    } finally {
      setLoading(false);
    }
  };

  const onSearch = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortBy: "categoryName",
        sortDirection: "ASC",
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      const categoryListingResponse = await categoryListingSearchService(
        requestBody,
        searchValue
      );

      if (categoryListingResponse.statusCode === 6) {
        if (categoryListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setCategoryList(categoryListingResponse.data.content);
        setTotalElements(categoryListingResponse.data.totalElements);
      } else {
        showNotification("Error", categoryListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        active: 2,
        filterSearch: searchValue ? searchValue.trim() : null,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
      };
      const response = await categoryListingService(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setCategoryList([...categoryList, ...response.data.content]);
        } else {
          setCategoryList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch category list data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  return (
    <CategoryList
      totalElements={totalElements}
      setCategoryList={setCategoryList}
      onSearch={onSearch}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      fetchCategoryList={fetchCategoryList}
      categoryList={categoryList}
      noRecord={noRecord}
    />
  );
};

export default ProductCategory;
